import {colors} from "@unibuddy/patron";
import {PRIMARY_COLOR, PRIMARY_HOVER_COLOR} from "./theme";

export const chatTheme = {
    Button: {
        colors: {
            chat: {
                color: colors.grey700,
                bgColor: colors.grey200,
                borderColor: "transparent",
                hoverBgColor: colors.grey200,
                outlineColor: colors.grey700,
                clearColor: colors.grey700,
                clearHoverBgColor: colors.grey200,
            },
            activeChat: {
                color: "white",
                bgColor: PRIMARY_COLOR,
                borderColor: "transparent",
                hoverBgColor: PRIMARY_HOVER_COLOR,
                outlineColor: colors.blue400,
                clearColor: colors.grey600,
                clearHoverBgColor: colors.grey100,
            },
        },
    },
    chat: {
        disabled: {
            backgroundColor: colors.grey200,
        },
        footer: {
            backgroundColor: colors.grey50, // Adding transparency here causes bugs with scroll blur
        },
        input: {
            color: colors.grey700,
            backgroundColor: "white",
            boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.08)",
            paddingTop: "10px", // used to position the placeholder to be visually centered
            placeholderColor: colors.grey700,
        },
        message: {
            backgroundColor: PRIMARY_COLOR,
            textColor: "white",
            linkColor: "white",
            altBackgroundColor: "white",
            altTextColor: colors.grey900,
            altLinkColor: colors.blue600,
        },
        scroll: {
            backgroundColor: colors.grey50,
            gradientBgColorTop: "#FFFFFF00",
            gradientBgColorBottom: "white",
        },
    },
};
